import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SOFTLINE_FEATURE_TITLE, TitleStore } from '@softline/application';
import { Router, RouterModule } from '@angular/router';
import { Store } from '@softline/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'lib-customer-query',
    templateUrl: './customer-query.component.html',
    styleUrls: ['./customer-query.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule]
})
export class CustomerQueryComponent implements OnInit, OnDestroy {
  constructor(private store: Store, protected router: Router) {}

  ngOnInit() {
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      '#CUSTOMER.TITLE'
    );
  }

  ngOnDestroy() {
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setTitle,
      ''
    );
    this.store.commit(
      SOFTLINE_FEATURE_TITLE,
      TitleStore.mutations.setSubTitle,
      ''
    );
  }
}
